import script from "./LoginComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginComponents.vue?vue&type=script&setup=true&lang=js"

import "./LoginComponents.vue?vue&type=style&index=0&id=128e7c9f&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128e7c9f"]])

export default __exports__